namespace TabAurous.Administration {
    export interface SendCampaignForm {
        Code: Serenity.StringEditor;
        ScheduleTypeId: Serenity.LookupEditor;
        ProviderId: Serenity.LookupEditor;
        Party: Serenity.ServiceLookupEditor;
        UseTemplate: Serenity.BooleanEditor;
        TemplateId: Serenity.LookupEditor;
        Title: Serenity.StringEditor;
        Message: Serenity.TextAreaEditor;
        Image: Serenity.ImageUploadEditor;
        Html: Serenity.HtmlContentEditor;
        Schedule: Schedule;
        DateTime: Serenity.DateTimeEditor;
        Recurring: RecurringEditor;
        ProviderType: Serenity.StringEditor;
    }

    export class SendCampaignForm extends Serenity.PrefixedContext {
        static formKey = 'Administration.SendCampaign';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!SendCampaignForm.init)  {
                SendCampaignForm.init = true;

                var s = Serenity;
                var w0 = s.StringEditor;
                var w1 = s.LookupEditor;
                var w2 = s.ServiceLookupEditor;
                var w3 = s.BooleanEditor;
                var w4 = s.TextAreaEditor;
                var w5 = s.ImageUploadEditor;
                var w6 = s.HtmlContentEditor;
                var w7 = Schedule;
                var w8 = s.DateTimeEditor;
                var w9 = RecurringEditor;

                Q.initFormType(SendCampaignForm, [
                    'Code', w0,
                    'ScheduleTypeId', w1,
                    'ProviderId', w1,
                    'Party', w2,
                    'UseTemplate', w3,
                    'TemplateId', w1,
                    'Title', w0,
                    'Message', w4,
                    'Image', w5,
                    'Html', w6,
                    'Schedule', w7,
                    'DateTime', w8,
                    'Recurring', w9,
                    'ProviderType', w0
                ]);
            }
        }
    }
}
